import { createContext, useState } from "react";

export const ThemeContext = createContext(null);
export const ThemeProvider = ({ children }) =>
    {
        const [theme, setTheme] = useState('dark')
        const toggleTheme = () => 
            {
                setTheme(theme === 'dark' ? 'light' : 'dark')

            }

            return(
                <ThemeContext.Provider value={{ theme, toggleTheme}}>
                    {children}
                </ThemeContext.Provider>
            )
    }